import React from "react";
const Terms = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled">
              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
                <h4 className="title_text text-dark mb-3">TopCoin UK - General Terms &amp; Conditions</h4>
                <p className="text-dark fw-semibold opacity-50 mb-0">Effective Date: 6 September 2026</p>
                <p className="text-dark fw-semibold opacity-50 mb-0">TopCoin UK Ltd | Company Registration No. 16483297</p>
                <p className="text-dark fw-semibold opacity-50 mb-3">Email: info@topcoinuk.com</p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">1. Introduction</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  These General Terms &amp; Conditions ("Terms") govern your access to and use of the <strong>TopCoin UK website, platform, account, TopCoin Wallet and related services</strong> ("Services").
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  By creating an account or using the Services, you agree to these Terms.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK operates an <strong>advertising, customer loyalty and rewards platform</strong> through which customers may discover participating companies, shops and retailers, access qualifying offers and receive TopCoin rewards.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  These Terms apply to the general TopCoin UK platform. Where you participate in the <strong>Captain TC Rewards Programme</strong>, the separate Captain TC Rewards Programme Terms &amp; Conditions also apply.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">2. About TopCoin UK</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK Ltd ("TopCoin UK", "we", "us" or "our") is a company registered in England and Wales under company number <strong>16483297</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK provides advertising, promotional and loyalty services connecting customers with participating companies, shops and retailers.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Participating businesses may be promoted through the TopCoin UK platform and may make products, services, offers and promotions available to customers.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">3. Customer Eligibility</h5>
                <p className="info_description text-dark opacity-50 mb-2">To create and use a TopCoin UK account, you must:</p>
                <ul className="text-dark opacity-50 ms-4 mb-2" style={{ listStyleType: "disc" }}>
                  <li>Be at least <strong>18 years old</strong>;</li>
                  <li>Provide accurate and current registration information;</li>
                  <li>Maintain only the number of accounts permitted by TopCoin UK;</li>
                  <li>Use your account for lawful purposes; and</li>
                  <li>Comply with these Terms.</li>
                </ul>
                <p className="info_description text-dark opacity-50 mb-0">
                  We may carry out reasonable checks to verify account information, transactions and reward eligibility.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">4. Account Registration</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  To use certain TopCoin UK Services, including the wallet system, you must create an account and provide the information requested during registration.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  You are responsible for keeping your login details secure and confidential.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  You must notify TopCoin UK if you believe your account has been accessed without your permission or your login details have been compromised.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  You are responsible for ensuring that the information associated with your account remains accurate and up to date.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">5. TopCoin Wallet</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Eligible customers may have access to a <strong>TopCoin Wallet</strong> within their TopCoin UK account.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The TopCoin Wallet is used to record and display qualifying TopCoin credited to the customer's account.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Wallet balances and TopCoin activity are recorded internally within the TopCoin UK platform.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The TopCoin Wallet is part of the TopCoin UK loyalty and rewards system and is not intended to operate as a conventional bank account.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">6. TopCoin</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  <strong>TopCoin are digital loyalty and reward units used within the TopCoin UK platform.</strong>
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers may receive qualifying TopCoin when they make eligible purchases, participate in qualifying promotions or complete other activities specified by TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The amount of TopCoin available for a particular purchase, business or promotion may vary.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin credited to a customer's account will be recorded in the customer's TopCoin Wallet.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Unless TopCoin UK expressly states otherwise for a particular promotion, TopCoin cannot be sold, traded or transferred between customers.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin itself is not cash and has no standalone monetary or exchange value outside the TopCoin UK rewards system.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">7. How Customers Earn TopCoin</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers may receive TopCoin through qualifying purchases, transactions, offers or promotions involving <strong>participating companies, shops and retailers</strong> available or promoted through the TopCoin UK platform.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Not every business, product, service or transaction appearing on the platform will necessarily qualify for TopCoin.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The applicable offer or promotion will determine whether a transaction qualifies and the amount of TopCoin available.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK may apply a reasonable validation period before TopCoin is confirmed and credited.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">8. Participating Companies, Shops and Retailers</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may work with participating <strong>companies, shops, retailers and other businesses</strong> to advertise and promote their products, services and offers to TopCoin UK customers.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Participating businesses may pay TopCoin UK for advertising, promotional, loyalty or related commercial services.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The exact commercial arrangement between TopCoin UK and a participating business may vary.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  A business appearing on the TopCoin UK platform does not automatically mean that every product, service or transaction offered by that business qualifies for TopCoin or another TopCoin UK reward.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers should check the applicable offer conditions before making a purchase.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">9. Purchases from Participating Businesses</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Unless expressly stated otherwise, products and services promoted through TopCoin UK are sold by the relevant participating company, shop or retailer.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The relevant seller is responsible for the underlying sale, including applicable product information, pricing, payment, delivery, returns, refunds, warranties and other seller obligations.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The seller's own terms and conditions may apply to the purchase.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Nothing in these Terms affects your statutory consumer rights.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">10. Qualifying Transactions</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin will only be awarded for transactions, purchases, activities or promotions that satisfy the applicable qualifying conditions.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  A transaction may need to be successfully completed and verified before TopCoin is confirmed.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may use information provided by participating businesses, affiliate networks or other service providers to determine whether a transaction qualifies.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin may not be awarded where a transaction cannot reasonably be verified as qualifying.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">11. Returns, Refunds, Cancellations and Reversed Transactions</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  If a transaction for which TopCoin has been awarded is subsequently <strong>cancelled, returned, refunded, reversed, charged back or determined to be invalid</strong>, the corresponding TopCoin may be cancelled, removed or adjusted.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  This may result in the customer's TopCoin Wallet balance being adjusted accordingly.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Nothing in this section restricts or removes a customer's statutory rights to cancel, return or obtain a refund where those rights apply.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">12. Captain TC Rewards Programme</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK also operates the separate <strong>Captain TC Rewards Programme</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Captain TC Rewards Cards, Captain TC Rewards TopCoin, Captain TC Gold Cards and associated Captain TC rewards are governed by the separate <strong>Captain TC Rewards Programme Terms &amp; Conditions</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Participation in the general TopCoin UK platform does not by itself guarantee eligibility for Captain TC rewards.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers wishing to participate in Captain TC Rewards must satisfy the applicable Captain TC eligibility requirements.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where there is a specific Captain TC programme rule, the Captain TC Rewards Programme Terms &amp; Conditions apply to that programme.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">13. Promotional Offers and Rewards</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may make promotional offers and rewards available from time to time.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Each promotion may have additional eligibility criteria, qualifying periods, reward limits or other conditions.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where additional conditions are displayed for a particular promotion, those conditions apply in addition to these General Terms &amp; Conditions.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Promotional offers may be changed, withdrawn or replaced, subject to applicable law and any rights already acquired by customers.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">14. Third-Party Rewards</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may offer rewards provided or fulfilled through third parties, including participating companies, shops, retailers and other reward providers.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  These may include gift cards, eGift cards, vouchers, products or other promotional benefits.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Third-party rewards may be subject to the provider's own terms and conditions, including expiry dates and restrictions on use.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The applicable third-party conditions should be reviewed before using the reward.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">15. Acceptable Use</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  You agree to use TopCoin UK and its Services lawfully.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">You must not:</p>
                <ul className="text-dark opacity-50 ms-4 mb-0" style={{ listStyleType: "disc" }}>
                  <li>Manipulate or attempt to manipulate TopCoin balances or transactions;</li>
                  <li>Create accounts for fraudulent purposes;</li>
                  <li>Provide deliberately false information;</li>
                  <li>Interfere with the operation or security of the platform;</li>
                  <li>Attempt to register or claim rewards to which you are not entitled;</li>
                  <li>Exploit technical errors or system vulnerabilities;</li>
                  <li>Use another person's account without authorisation; or</li>
                  <li>Use the Services for unlawful, fraudulent or abusive purposes.</li>
                </ul>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">16. Fraud and Misuse</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may investigate activity where we reasonably suspect fraud, manipulation, abuse or a material breach of these Terms.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where appropriate, TopCoin UK may temporarily suspend affected TopCoin or rewards while the relevant activity is investigated.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where fraud or material misuse is reasonably established, TopCoin UK may remove improperly obtained TopCoin or rewards, suspend access to the Services or terminate the relevant account.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">17. Account Suspension and Termination</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may suspend or terminate an account where there is a material breach of these Terms, fraud, misuse, unlawful activity or a material threat to the security or integrity of the platform.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where reasonably practicable and appropriate, we will provide notice of significant account action.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers may request closure of their TopCoin UK account by contacting TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Account closure does not affect rights or obligations that arose before the account was closed.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">18. Intellectual Property</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  All intellectual property rights in the TopCoin UK platform, branding, logos, designs, software, website content and other proprietary materials belong to TopCoin UK Ltd or the relevant rights holder.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  You may not reproduce, copy, modify, distribute, sell or commercially exploit TopCoin UK intellectual property without prior written permission, except where permitted by law.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Third-party trademarks and branding appearing on the platform remain the property of their respective owners.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">19. Privacy and Personal Information</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK processes personal information in accordance with its <strong>Privacy Policy</strong> and applicable data-protection law.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Personal information may be processed for purposes including account registration and administration; operation of the TopCoin Wallet; recording qualifying transactions and TopCoin; reward administration; customer support; fraud prevention; security; and compliance with applicable legal obligations.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers should review the TopCoin UK Privacy Policy for further information about how their personal information is handled.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">20. Platform Availability</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK aims to provide reliable access to its Services but cannot guarantee that the website, platform or wallet will always be available without interruption.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Maintenance, technical problems, third-party services, security issues or circumstances outside TopCoin UK's reasonable control may occasionally affect availability.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where reasonably possible, TopCoin UK will seek to restore affected Services promptly.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">21. Responsibility and Liability</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK will provide its Services with reasonable care and skill.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK is not responsible for losses caused by circumstances outside its reasonable control.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where a participating company, shop or retailer sells a product or service directly to the customer, responsibility for that underlying sale remains with the relevant seller, subject to applicable law.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Nothing in these Terms excludes or limits liability where doing so would be unlawful, including liability that cannot legally be excluded or restricted.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Nothing in these Terms affects your statutory consumer rights.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">22. Changes to TopCoin UK Services</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may develop, modify or improve its platform, wallet, rewards system, participating-business arrangements and other Services from time to time.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Changes may be necessary for commercial, operational, technical, security, legal or regulatory reasons.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where a material change affects existing customers' rights, TopCoin UK will provide appropriate notice where required.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">23. Changes to These Terms</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may update these Terms from time to time.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The latest version will be published on the TopCoin UK website with the applicable effective or updated date.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where required, customers will be given appropriate notice of material changes.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Changes will not remove mandatory consumer rights provided by law.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">24. Governing Law and Jurisdiction</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  These Terms are governed by the <strong>laws of England and Wales</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  If you are a consumer living elsewhere in the United Kingdom, you may also have mandatory rights under the laws applicable where you live.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Nothing in these Terms removes any mandatory consumer protections or rights that apply to you.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">25. Contact Us</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Questions regarding these General Terms &amp; Conditions or the TopCoin UK Services can be sent to:
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  <strong>TopCoin UK Ltd</strong><br />
                  Company Registration No.: 16483297<br />
                  Email: <strong>info@topcoinuk.com</strong>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Terms;
